<template>
  <!-- 我的课件 -->
  <div class="myCourseware">
    <!-- 时间筛选 -->
    <div class="timeNav">
      <div class="timeStr">时间</div>
      <div
        :class="['timeItem', timeNavIndex === item.id ? 'timeIsSelected' : '']"
        v-for="item in timeNavList"
        :key="item.id"
        @click="changeTimeIndex(item.id)"
      >
        {{ item.name }}
      </div>
      <div>
        <a-date-picker
          v-model="startValue"
          :disabled-date="disabledStartDate"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="Start"
          @openChange="handleStartOpenChange"
        />
        <span class="centerStr">至</span>
        <a-date-picker
          v-model="endValue"
          :disabled-date="disabledEndDate"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="End"
          :open="endOpen"
          @openChange="handleEndOpenChange"
        />
      </div>
    </div>
    <!-- 状态筛选 -->
    <div class="statusNav">
      <div class="statusStr">状态</div>
      <div
        :class="[
          'statusItem',
          statusNavIndex === item.id ? 'statusIsSelected' : '',
        ]"
        v-for="item in statusNavList"
        :key="item.id"
        @click="changeStatusIndex(item.id)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="table">
      <a-table :columns="columns" :data-source="data">
        <a slot="name" slot-scope="text">{{ text }}</a>
      </a-table>
    </div>
  </div>
</template>

<script>
const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park, New York No. 1 Lake Park",
    tags: ["nice", "developer"]
  },
  {
    key: "2",
    name: "Jim Green",
    age: 42,
    address: "London No. 2 Lake Park, London No. 2 Lake Park",
    tags: ["loser"]
  },
  {
    key: "3",
    name: "Joe Black",
    age: 32,
    address: "Sidney No. 1 Lake Park, Sidney No. 1 Lake Park",
    tags: ["cool", "teacher"]
  }
];

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    scopedSlots: { customRender: "name" }
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
    width: 80
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address 1",
    ellipsis: true
  },
  {
    title: "Long Column Long Column Long Column",
    dataIndex: "address",
    key: "address 2",
    ellipsis: true
  },
  {
    title: "Long Column Long Column",
    dataIndex: "address",
    key: "address 3",
    ellipsis: true
  },
  {
    title: "Long Column",
    dataIndex: "address",
    key: "address 4",
    ellipsis: true
  }
];
const timeNavList = [
  { id: 0, name: "近7天" },
  { id: 1, name: "近1个月" },
  { id: 2, name: "近3个月" },
  { id: 3, name: "近1年" }
];
const statusNavList = [
  { id: 0, name: "待审核" },
  { id: 1, name: "已通过" },
  { id: 2, name: "退稿" }
];
export default {
  name: "MyCourseware", // 我的课件
  data() {
    return {
      data,
      columns,
      timeNavList,
      statusNavList,
      timeNavIndex: 0,
      statusNavIndex: 0,
      startValue: null,
      endValue: null,
      endOpen: false
    };
  },
  watch: {
    startValue(val) {
      console.log("startValue", val);
    },
    endValue(val) {
      console.log("endValue", val);
    }
  },
  methods: {
    disabledStartDate(startValue) {
      const endValue = this.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    // 切换状态
    changeStatusIndex(id) {
      this.statusNavIndex = id;
    },
    // 切换时间
    changeTimeIndex(id) {
      this.timeNavIndex = id;
    }
  }
};
</script>

<style lang="less" scoped>
.myCourseware {
  .timeNav {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 927px;

    .timeStr {
      margin-right: 20px;
      color: #333333;
      font-size: 20px;
      font-weight: 600;
    }

    .timeItem {
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      color: #666666;
      text-align: center;
      border-radius: 30px;
    }

    .timeIsSelected {
      background: #ddf4ff;
    }

    .centerStr {
      margin: 0 20px;
    }
  }

  .statusNav {
    display: flex;
    align-items: center;
    width: 927px;

    .statusStr {
      margin-right: 20px;
      color: #333333;
      font-size: 20px;
      font-weight: 600;
    }

    .statusItem {
      margin-right: 10px;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      border-radius: 30px;
      text-align: center;
      font-size: 20px;
      color: #666666;
    }

    .statusIsSelected {
      background: #ddf4ff;
    }
  }

  .table {
    width: 927px;
    height: 522px;
    border-radius: 20px;
    border: 1px solid #66a8f5;
    box-sizing: border-box;
    overflow: hidden;
  }
}

/deep/ .ant-calendar-picker-input.ant-input {
  border-radius: 20px;
}
</style>
